<template>
  <div>
    <div class="field mt-5">
      <b-card no-body>
        <b-nav pills card-header slot="header">
          <b-nav-item :href="'#'+ term.id" @click="scrollIntoView" :active="activeNavItem === term.id"
                      v-for="(term,key) in terms" :key="key">{{ term.title }}
          </b-nav-item>
        </b-nav>

        <b-card-body v-for="(term,key) in terms" :key="key" v-show="activeNavItem === term.id"
                     @scroll="checkIfScrolledToBottom($event, term.id)"
                     :ref="`content-${term.id}`"
                     style="position:relative; height:300px; overflow-y:scroll;"
        >
          <h4 :id="term.id">{{ term.title }}</h4>
          <p data-v-203fc5f5="" class="termsinside_notice">
            ※ 完整閱讀後(內文拉到底)將自動勾選聲明事項
          </p>
          <div v-html="term.content"></div>
        </b-card-body>
      </b-card>
      <div class="field mt-5">
        <label class="checkbox" v-for="(term,key) in terms" :key="key">
          <input type="checkbox" name="termsCheck" v-model="termsCheck[term.id]"/>
          我已閱讀過會員規章(<a :href="term.link" style="color: #72ca4a" target="_blank">{{ term.title }}</a>)，並願意遵守規則。
        </label>
      </div>
    </div>
    <div class="send_submit">
      <button class="btn btn-primary active" role="button" aria-pressed="true" title="" @click="register('fb')">FACEBOOK 登入</button>
      <button type="button" class="btn btn-primary" @click="register">確認註冊</button>
      <button type="submit" hidden></button>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
export default {
  name: 'Terms',
  props: {
    terms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeNavItem: '',
      termsCheck: {},
      faceBookUrl: 'user/login/oauth/redirect?provider=facebook'
    };
  },
  mounted() {
    this.activeNavItem = this.terms[0].id;
    for (let i = 0; i < this.terms.length; i++) {
      this.$set(this.termsCheck, this.terms[i].id, false);
    }
  },
  methods: {
    register(type = null){
      let submitEle = $('.send_submit').find('[type="submit"]');

      // 創建一個陣列來儲存所有未接受的條款
      let unacceptedTerms = [];

      // 遍歷 this.termsCheck 物件中的每一個條款
      for (const term in this.termsCheck) {
        // 如果條款的值是 false
        if (this.termsCheck[term] === false) {
          // 找出對應的 title
          let termTitle = this.terms.find(t => t.id === term)?.title;
          // 將標題添加到陣列中
          unacceptedTerms.push(termTitle);
        }
      }

      // 如果有未接受的條款，則顯示它們
      if (unacceptedTerms.length > 0) {
        swal({text: `${unacceptedTerms.join(", ")}`, icon: "warning", title: `請接受以下條款`});
        return;
      }

      // 如果所有條款都已接受，則繼續執行
      if (type === 'fb') {
        window.location.href = this.faceBookUrl;
      } else {
        submitEle.click();
      }
    },
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(event) {
      event.preventDefault();
      const href = event.target.getAttribute('href');
      const hrefWithoutHash = href ? href.substring(1) : null;
      this.activeNavItem = hrefWithoutHash;
      const el = hrefWithoutHash ? document.querySelector('#' + hrefWithoutHash) : null;
      if (el) {
        this.$refs[`content-${hrefWithoutHash}`][0].scrollTop = el.offsetTop;
      }
    },
    checkIfScrolledToBottom(event, termId) {
      const el = event.target;
      const isScrolledToBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 5;

      if (isScrolledToBottom) {
        this.$set(this.termsCheck, termId, true);
      }
    },

  }
};
</script>

<style scoped>

</style>
